import React from "react";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const OutletsDropdown = ({
  resources,
  outlets,
  outlet,
  onOutletChange,
  containerClass,
  labelText = null,
  defaultValue = null,
  id = "outlet-dropdown",
  disabled = false,
  required = false,
  addMarginBottom = false,
  filterFunction = null,
  helperText = null,
  noPlaceholder = false
}) => {
  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={labelText ?? resources["Outlet"]}
      value={outlet}
      placeholder={noPlaceholder ? null : defaultValue ?? resources["All"]}
      values={outlets}
      inputName="outlet"
      handleChange={onOutletChange}
      addMarginBottom={addMarginBottom}
      disabled={disabled}
      required={required}
      containerClass={containerClass}
      map={x => ({ key: x.id, name: x.description })}
      filter={filterFunction}
      helperText={helperText}
    />
  );
};

export default OutletsDropdown;
